
// The copay table block of the builder's plan card (#721 spec §8.2 step 5):
// the existing deductible sentence and DrugsMonthlyByDrug, with the new intro
// sentence (A.10) and without the "detailed copay breakdown" sentence.
import { rxIntroHtml } from '~/util/aep-recommendation'
import { deductibleTiersText } from '~/util/deductible-tiers'
import { toMoneyNumber } from '~/util/string'

export default {
    props: {
        plan: { type: Object, required: true },
        enginePlan: { type: Object, required: true },
    },
    computed: {
        deductible () {
            return toMoneyNumber(this.enginePlan.drug_deductible) || 0
        },
        tiersText () {
            return deductibleTiersText(this.plan.drug_deductible_applicable_tiers, this.plan.drug_deductible_all_tiers)
        },
        intro () {
            return rxIntroHtml(this.enginePlan)
        },
    },
}
